import PatternsPage from './PatternsPage'

export default PatternsPage